<template>
    <div>
        <div class="row d-flex align-items-center justify-content-start pl-4">
            <div class="col-10 mb-5">
                <Button
                    v-if="!$route.path.includes('new') && !$route.path.includes('update')"
                    @click="$router.go(-1)" 
                    class="mb-3" 
                    size="small"
                    type="outline" 
                    color="grey"
                >
                    <ArrowDropdown :rotate="90" class="mr-2" :color="`#727D94`"/>
                     Voltar
                </Button>
                <h3 class="c-ndarkthree mb-0">
                    <span class="bold">{{ partnerTitle }}</span> | Dados gerais
                </h3>
            </div>
            <div class="col-10 mb-5">
                <el-form :model="partner" ref="partner">
                    <div class="row mb-4">
                        <div class="col-6">
                            <el-form-item prop="name" class="mb-0">
                                <label>Nome do parceiro</label>
                                <el-input  
                                    v-model="partner.name" 
                                    placeholder="Nome do parceiro"
                                    :disabled="!$route.path.includes('new')"
                                />
                            </el-form-item>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <el-form-item prop="mainSponsorCnpj" class="mb-0">
                                <label>CNPJ do financiador principal</label>
                                <el-input  
                                    :class="getPrimaryColor" 
                                    v-model="partner.mainSponsorCnpj" 
                                    placeholder="CNPJ da empresa" 
                                    v-mask="'##.###.###/####-##'"
                                    @input="validateCnpj" 
                                />
                            </el-form-item>
                            <div v-if="helpMessage.length" class="help-message c-error">
                                {{ helpMessage }}
                            </div>
                            <CnpjNameCard
                                class="mt-2"
                                v-else-if="isCnpjValid === true"
                                :name="partner.mainSponsorName" 
                            />
                        </div>
                    </div>   
                </el-form>
            </div>
            <div class="col-10">
                <el-form :model="partner" ref="partner">
                    <h5 class="mb-4">Regras</h5>
                    <div class="row mb-4">
                        <div class="col-6">
                            <el-form-item prop="erp" class="mb-0">
                                <label>Integração com ERP do financiador</label>
                                <el-select  
                                    :value="partner.erp"    
                                    v-model="partner.erp"   
                                    placeholder="Selecione"
                                    :popper-class="getPrimaryColor" 
                                >
                                    <el-option label="Sem integração" :value="null"/>
                                    <el-option label="Black101" :value="'Black101'" />
                                    <el-option label="Qprof" :value="'Qprof'" />
                                </el-select>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="row mb-4">
                        <div class="col-6">
                            <el-form-item prop="signingPlatform" class="mb-0">
                                <label>Integração com plataforma de assinatura</label>
                                <el-select  
                                    :value="partner.signingPlatform"    
                                    v-model="partner.signingPlatform"   
                                    placeholder="Selecione"
                                    :popper-class="getPrimaryColor" 
                                >
                                    <el-option label="Sem integração" :value="null"/>
                                    <el-option label="QCertifica" :value="'QCertifica'" />
                                </el-select>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="row mb-4">
                        <div class="col-6">
                            <el-form-item prop="registerModel" class="mb-0">
                                <label>Modelo de cadastro do cedente</label>
                                <el-select 
                                    :value="partner.registerModel"
                                    v-model="partner.registerModel"     
                                    placeholder="Selecione"
                                    :popper-class="getPrimaryColor" 
                                >
                                    <el-option label="Cadastro simplificado" :value="`simplificado`"/>
                                    <el-option label="Cadastro completo" :value="`completo`" />
                                    <el-option label="Customizado" :value="`customizado`" />
                                </el-select>
                            </el-form-item>
                        </div>
                    </div>
                    <div v-if="partner.registerModel === 'customizado'" class="mb-4">
                        <div class="mb-3">
                            <p class="medium mb-3">Documentos da empresa</p>
                            <div class="d-flex col-8 justify-content-between pl-0">
                                <div class="col-7 pl-0">
                                    <el-checkbox :class="`${getPrimaryColor} mb-3`" v-model="customRegisterModel.contract" label="Contrato social" />
                                    <el-checkbox :class="`${getPrimaryColor} mb-3`" v-model="customRegisterModel.update" label="Última atualização contratual (se houver)" />
                                    <el-checkbox :class="`${getPrimaryColor} mb-3`" v-model="customRegisterModel.minutes" label="Ata de assembleia" />
                                    <el-checkbox :class="`${getPrimaryColor} mb-3`" v-model="customRegisterModel.card" label="Cartão CNPJ" />
                                </div>
                                <div class="col-8">
                                    <el-checkbox :class="`${getPrimaryColor} mb-3`" v-model="customRegisterModel.declaration" label="Declaração de Instituições Financeiras" />
                                    <el-checkbox :class="`${getPrimaryColor} mb-3`" v-model="customRegisterModel.invoicing" label="Faturamento dos últimos 24 meses" />
                                    <el-checkbox :class="`${getPrimaryColor} mb-3`" v-model="customRegisterModel.balance" label="Balanço dos últimos 24 meses" />
                                    <el-checkbox :class="`${getPrimaryColor} mb-3`" v-model="customRegisterModel.dre" label="DRE dos últimos 24 meses" />
                                </div>
                            </div> 
                        </div>
                        <div>
                            <p class="medium mb-3">Documentos dos sócios PF e procuradores</p>
                            <div class="d-flex col-8 justify-content-between pl-0">
                                <div class="col-7 pl-0">
                                    <el-checkbox :class="`${getPrimaryColor} mb-3`" v-model="customRegisterModel.identification" label="RG e CPF ou CNH vigente" />
                                    <el-checkbox :class="`${getPrimaryColor} mb-3`" v-model="customRegisterModel.proxy" label="Procuração P.F. (aval) dos procuradores. " />
                                    <el-checkbox :class="`${getPrimaryColor} mb-3`" v-model="customRegisterModel.residence" label="Comprovante de Residência" />
                                </div>
                                <div class="col-8">
                                    <el-checkbox :class="`${getPrimaryColor} mb-3`" v-model="customRegisterModel.ir" label="Declaração de Imposto de Renda" />
                                    <el-checkbox :class="`${getPrimaryColor} mb-3`" v-model="customRegisterModel.marriage " label="Certidão de casamento (se aplicável)" />
                                    <el-checkbox :class="`${getPrimaryColor} mb-3`" v-model="customRegisterModel.spouse" label="RG e CPF ou CNH vigente do cônjuge (se aplicável)" />
                                </div>
                            </div> 
                        </div>
                    </div>
                </el-form>
            </div>
            <div class="col-10">
                <p class="bold mb-3">Mostrar dados do financiador na proposta?</p>
                <el-radio :class="getPrimaryColor" v-model="partner.showSponsorData" :label="true">Sim</el-radio>
                <el-radio :class="getPrimaryColor" v-model="partner.showSponsorData" :label="false">Não</el-radio>
            </div>
            <div v-if="!$route.path.includes('new') && !$route.path.includes('update')" class="col-10 mt-4">
                <Button @click="saveData" class="" :color="getPrimaryColor">
                    Salvar alterações
                </Button>
            </div>
        </div>
        <PartnerCard 
            v-if="$route.path.includes('new') || $route.path.includes('update')"
            @createNewPartner="createNewPartner"
            @newMainRules="saveData"
            @toGoBack="toGoBack"
        />
    </div>
</template>

<script>
import store from '@/store'
import { capitalize } from "lodash"
import CnpjNameCard from '@/components/cards/CnpjNameCard'
import PartnerCard from '@/components/cards/PartnerCard.vue'
import ArrowDropdown from '@/components/icons/ArrowDropdown'


//API - CREATE
import insertNewPartner from '@/api/insertNewPartner'
import insertNewPartnerRules from '@/api/insertNewPartnerRules'
import insertCompany from '@/api/insertCompany'
import setSponsorPartners from '@/api/setSponsorPartners'

//API - READ
import getCompanyName from '@/api/getCompanyName'
import getSponsorsByPartnerId from '@/api/getSponsorsByPartnerId'
import getPartnerRules from "@/api/getPartnerRules"
import getCnpjIsRegistered from "@/api/getCnpjIsRegistered"
import getSponsorById from "@/api/getSponsorById"
import validateCnpjType from '@/api/validateCnpjType'

//API - UPDATE
import updateCompany from '@/api/updateCompany'
import updateSponsorPartner from '@/api/updateSponsorPartner'
import updatePartner from '@/api/updatePartner'
import updatePartnerRules from '@/api/updatePartnerRules'


import removeMask from '@/utils/removeMask'

export default {
    components: {
        CnpjNameCard,
        PartnerCard,
        ArrowDropdown,
    },
    data() {
        return {
            partnerRulesId: '',
            hasMainSponsor: false,
            partnerSponsors: [],
            currentMainSponsor: {
                id: '',
                cnpj: ''
            },
            partner: {
                name: '',
                mainSponsorCnpj: '',
                mainSponsorName: '',
                erp: '',
                signingPlatform: '',
                registerModel: '',
                showSponsorData: '',
            },
            customRegisterModel: {},
            isCnpjValid: false,
            helpMessage: '',
        }
    },
    computed: {
        partnerTitle() {
            const newPartner = this.$route.path.includes('new')
            const isUpdate = this.$route.path.includes('update')
            if(newPartner || isUpdate) return 'Novo parceiro'
            return this.partner.name
        }
    },
    methods: {
        notifySuccess() {
            this.$notify({
                title: 'Dados salvos com sucesso.',
                message: '',
                type: 'success',
                duration: 3000,
                offset: 100,
                showClose: false,
            })
        },
        notifyError() {
            this.$notify({
                title: 'Opa! Encontramos algum erro.',
                message: '',
                type: 'error',
                duration: 3000,
                offset: 100,
                showClose: false,
                customClass: 'error'
            });
        },
        formatCnpj(cnpj) {
            let formatedCnpj = cnpj.padStart(14, '0')
            formatedCnpj = cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
            this.partner.mainSponsorCnpj = formatedCnpj
        },
        async validateCnpj() {
            if (!this.partner.mainSponsorCnpj.length) {
                this.isCnpjValid = false
                this.helpMessage = ''
            } else if (this.partner.mainSponsorCnpj.length < 18) {
               this.isCnpjValid = false
               this.helpMessage =  'O CNPJ deve ter 14 caracteres'
            } else {
               const sponsor = await getCompanyName(removeMask(this.partner.mainSponsorCnpj))
               this.isCnpjValid = sponsor.ok ? true : false
               this.partner.mainSponsorName = sponsor.ok ? sponsor.payload : ''
               this.helpMessage = sponsor.ok ? '' : 'CNPJ inválido' 
            }
        },
        async insertSponsor(partnerId, partnerName) {
            const cnpjIsRegistered = await getCnpjIsRegistered(removeMask(this.partner.mainSponsorCnpj))
            let sponsor = ''
            let mainSponsor = ''
            let mainSponsorId = ''
            let alreadyAssociated = false

            if(cnpjIsRegistered) {
                sponsor = await validateCnpjType(removeMask(this.partner.mainSponsorCnpj), '0')
                mainSponsorId = sponsor.companyId
                mainSponsor = await getSponsorById(mainSponsorId)
                alreadyAssociated = this.partnerSponsors.some(ps => ps.id == mainSponsorId)
            } else {
                mainSponsor = await insertCompany({
                    cnpj: removeMask(this.partner.mainSponsorCnpj),
                    companyType: "0",
                    partner: partnerId,
                })

                mainSponsor = mainSponsor.payload 
            }

            if (mainSponsor.visible != this.partner.showSponsorData) {
                await updateCompany(mainSponsor.cnpjId, { visible: this.partner.showSponsorData })
            }

            if(alreadyAssociated) {
                await updateSponsorPartner({
                    partnerId: this.$route.params.partnerId,
                    sponsorId: mainSponsorId,
                    main: true,
                    substitute: true
                })
            } else {
                await setSponsorPartners({
                    cnpjId: mainSponsor.cnpjId, 
                    partners: [ ...sponsor.partners, partnerName ],
                    main: true,
                })
            }
        },
        async createNewPartner() {
            try {
                //Novo parceiro e regras: 
                const { name, erp, signingPlatform, registerModel } = this.partner
                const newPartner = await insertNewPartner({ 
                    name: name.toUpperCase(),
                    externalErp: erp,
                    signingPlatform,
                })
                const { id } = newPartner
                await insertNewPartnerRules(id, {registerModel})

                //Novo financiador principal:
                await this.insertSponsor(id, newPartner.name)

                this.notifySuccess()

                this.$router.push(`/partners/new/${id}/sponsor`)
            } catch(e) {
                this.notifyError()
            }
        },
        async saveData() {
            try {
                if(this.partnerRulesId) {
                    const { registerModel, erp, signingPlatform } = this.partner
                    await updatePartner(this.$route.params.partnerId, { externalErp: erp, signingPlatform })
                    await updatePartnerRules(this.$route.params.partnerId, { registerModel})
                } else {
                    const { registerModel, erp, signingPlatform } = this.partner
                    await updatePartner(this.$route.params.partnerId, { externalErp: erp, signingPlatform })
                    await insertNewPartnerRules(this.$route.params.partnerId, { registerModel})
                }

                if(this.hasMainSponsor) {
                    const validateSponsor = this.currentMainSponsor.cnpj != removeMask(this.partner.mainSponsorCnpj)
                    if(validateSponsor) {
                        const updateData = {
                            partnerId: this.$route.params.partnerId,
                            sponsorId: this.currentMainSponsor.id,
                            main: false,
                        }
                        await updateSponsorPartner(updateData)
                        await this.insertSponsor(this.$route.params.partnerId, this.partner.name.toUpperCase())
                    }
                } else {
                    await this.insertSponsor(this.$route.params.partnerId, this.partner.name.toUpperCase())
                }

                this.notifySuccess()

                if(this.$route.path.includes('update')) this.$router.push(`/partners/new/${this.$route.params.partnerId}/sponsor`)
            } catch(e) {
                this.notifyError()
            }
        },
        toGoBack() {
            const isUpdate = this.$route.path.includes('update')
            if(isUpdate) return this.$router.push('/partners')
            return this.$router.go(-1)
        }
    },
    async created() {
        const newPartner = this.$route.path.includes('new')

        if(!newPartner) {
            store.commit('user/setLoading', true)

            let partnerData = await getSponsorsByPartnerId(this.$route.params.partnerId)
            const partnerRules = await getPartnerRules(this.$route.params.partnerId)
            
            partnerData = partnerData[0]
            this.partnerSponsors = partnerData.sponsors

            this.hasMainSponsor = partnerData.sponsors.some(p => p.sponsorPartners.main)
            
            if(partnerData.sponsors.length && this.hasMainSponsor) {
                const mainSponsor = partnerData.sponsors.find(p => p.sponsorPartners.main)

                this.isCnpjValid = true
                this.formatCnpj(mainSponsor.cnpj.cnpj)
                this.partner.mainSponsorName = mainSponsor.name
                this.partner.showSponsorData = mainSponsor.visible

                this.currentMainSponsor.id = mainSponsor.id
                this.currentMainSponsor.cnpj = mainSponsor.cnpj.cnpj
            }

            if(partnerRules) {
                this.partnerRulesId = partnerRules.id
                this.partner.registerModel = partnerRules.registerModel
                this.partner.erp = partnerRules.partner.externalErp
                this.partner.signingPlatform = partnerRules.partner.signingPlatform
            }
            
            this.partner.name = capitalize(partnerData.name)

            store.commit('user/setLoading', false)
        }
    }
}
</script>

<style lang="scss">
.help-message {
    font-size: 12px !important;
}
</style>